export default {
  cash: "",
  holdings: [],
};
